import { UserProject } from '@types';
import { memo } from 'react';
import BaseUserTable from './BaseUserTable';

export interface TitoTableProps {
  data?: UserProject[];
}

const TitoTable = ({ data }: TitoTableProps) => {
  return <BaseUserTable data={data} />;
};

export default memo(TitoTable);
